import { SOUND_TYPES_LOADING, SOUND_TYPES_SUCCESS, SOUND_TYPES_FAILED } from '../actions/soundManager.action';
import { SoundTypesReducer } from '../models/soundManager.interface';

const initialState: SoundTypesReducer = {
    soundTypes: {},
    soundTypesLoading: false,
    soundTypesError: false,
    soundTypesErrorMsg: '',
}

const soundTypesReducer = (state: SoundTypesReducer = initialState, action: any): SoundTypesReducer => {

    switch (action.type) {
        case SOUND_TYPES_LOADING:
            return {
                ...state,
                soundTypesLoading: true,
                soundTypesError: false
            }
        case SOUND_TYPES_SUCCESS:
            return {
                ...state,
                soundTypesLoading: false,
                soundTypesError: false,
                soundTypes: action.payload.res,
            }
        case SOUND_TYPES_FAILED:
            return {
                ...state,
                soundTypesLoading: false,
                soundTypesError: true,
                soundTypesErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

export default soundTypesReducer;